module.exports = "<div class=\"row\" infiniteScroll (scrolled)=\"onScroll()\" [@flyIn]=\"news?.length\">\n  <app-news-item *ngFor=\"let newsItem of news\" class=\"news col-12 col-lg-3 px-3 my-3\" [news]=\"newsItem\"></app-news-item>\n  <h2 class=\"col-12 my-5 py-3 p-md-5 text-center text-muted\" *ngIf=\"!news.length\">\n    Нет новостей\n  </h2>\n</div>\n\n<app-loader *ngIf=\"isLoading\"></app-loader>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/magazine/magazine-news/magazine-news.component.html
// module id = ./src/app/magazine/magazine-news/magazine-news.component.html
// module chunks = magazine.module